import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'

import 'swiper/scss'
import 'swiper/scss/navigation'

import classNames from 'classnames'

import styles from './testimonial_slider.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Title from './basic/title'
import Media from './basic/media'

function TestimonialSlider(props) {
	const fields = props.fields
	const sliderConfig = {
		modules: [Navigation],
		slidesPerView: '1',
		spaceBetween: 0,
		navigation: {
			prevEl: `.${styles.previous}`,
			nextEl: `.${styles.next}`,
			clickable: true
		},
	}

	return <BlockWrapper {...props} animateType='fade' className={classNames(styles.testimonials_slider, props.editor ? styles.editor : '')}>
		<div className={styles.testimonial_slider_wrapper}>
			<div className={styles.title_wrapper}>
				<Title fields={fields.title} className={styles.title} />
			</div>
			
			<button aria-label='previous' className={styles.previous}></button>
			<Swiper className={styles.slider} {...sliderConfig}>
				{fields.testimonials && fields.testimonials.map((slide, index) => {
					return <SwiperSlide className={styles.slide} key={index}>
						<div className={styles.testimonial_wrapper}>
							<div className={styles.testimonial} dangerouslySetInnerHTML={{__html: slide.testimonial}} />
							{slide.cite && <div className={styles.cite} dangerouslySetInnerHTML={{__html: '—' + slide.cite}} />}
						</div>
					</SwiperSlide>
				})}
			</Swiper>
			<button aria-label='next' className={styles.next}></button>

			<div className={styles.background_media_wrapper}>
				<Media {...fields.background_media} />
			</div>
		</div>
	</BlockWrapper>
}

export default TestimonialSlider